module.exports = __webpack_public_path__ + "img/max_acceleration_icon.11489929.png";